export default {
    roleInfo: {},
    userInfo: {},
    user: {},
    permission: [],
    userInfoCase: [],
    casesList: [],
    curentCase: {},
};